import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Parent Login (docs/DECISIONS.md, 2026-08-25 "Parent login..." decision) -
// same auth/token/expiry checks as ProtectedRoute.jsx, plus
// accountType==='parent'. Deliberately does NOT check verification status
// here - an unverified parent still reaches the dashboard shell, which
// shows a "verify your email" screen with a resend button instead of a
// hard redirect (the backend's own require_parent_login already 403s every
// read route for an unverified parent, so the page-level screen is the
// only enforcement that actually matters; this route guard only decides
// "are you logged in as a parent at all").
export default function ParentProtectedRoute({ children }) {
  const { user, token, tokenExpiresAt, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-white">
        <div className="h-10 w-10 rounded-full border-2 border-brand-blue border-t-transparent animate-spin" />
      </div>
    );
  }

  const tokenExpired = tokenExpiresAt && tokenExpiresAt <= Math.floor(Date.now() / 1000);
  if (!user || !token || tokenExpired) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }

  // A student who somehow lands on a parent-only URL goes to their own
  // home, not /login (they ARE logged in, just not as a parent).
  if (user.accountType !== 'parent') {
    return <Navigate to="/practice" replace />;
  }

  return children;
}
